import React, { Component } from 'react';
import './NowPlaying.css';
import $ from 'jquery';

class NowPlaying extends Component {

    amazonLink(artist, title){
        var amazonLink = 'https://www.amazon.com/gp/search?ie=UTF8&keywords='+encodeURIComponent(artist)+'-'+encodeURIComponent(title)+'&tag=muzbox-20&index=digital-music-track&linkCode=ur2&camp=1789&creative=9325';
        $('#amazon-link').attr('href', amazonLink);
    }


    render() {
        return (
            <div className="NowPlaying">
                <h3>"<span id="track-name">{ this.props.track.title }</span>" - <span id="album-name">{ this.props.track.album }</span></h3>
                <span id="artist-name">{ this.props.track.artist }</span>
            </div>
        );
    }
}

export default NowPlaying;



// WEBPACK FOOTER //
// ./src/NowPlaying.js